import React from 'react';
import { Box, Button, IconButton, Modal } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import DeleteOutlineRounded from '@material-ui/icons/DeleteOutlineRounded';
import useToast from '../../../hooks/useToast';
import useLoader from '../../../hooks/useLoader';
import { useDispatch } from 'react-redux';
import { deleteCartAsync, getAllCartAsync } from './CartStore/cartStoreSlice';

export const cartColumn = [
  { Header: 'User Name', accessor: 'user.name' },
  { Header: 'Email', accessor: 'user.email' },
  {
    Header: 'Total Price',
    accessor: '',
    Cell: (val) => {
      const payload = val.cell.row.original;
      const { items } = payload;
      return (
        <Box>
          {items.reduce((sum, item) => {
            return sum + item.price;
          }, 0)}
        </Box>
      );
    },
  },
  {
    Header: 'Items',
    accessor: 'items',
    Cell: (val) => {
      const payload = val.cell.row.original;
      const { items } = payload;
      return (
        <Box sx={{ maxWidth: 250 }}>
          {items.map((item) => item.title).join(', ')}
        </Box>
      );
    },
  },
  // { Header: 'Offer', accessor: 'offer' },
  // { Header: 'Created At', accessor: 'createdAt' },
  {
    Header: 'Action',
    accessor: '',
    Cell: (val) => {
      const dispatch = useDispatch();
      const payload = val.cell.row.original;
      const { _id } = payload;
      const { handleLoader } = useLoader();
      const { SuccessToast } = useToast();

      const [openConfirmModal, setOpenConfirmModal] = React.useState(false);

      const handleOpenModal = () => {
        setOpenConfirmModal(true);
      };
      const handleCloseModal = () => {
        setOpenConfirmModal(false);
      };

      const fetchData = async () => {
        try {
          dispatch(getAllCartAsync())
            .unwrap()
            .then(() => {});
        } catch (err) {
          console.log(err);
        }
      };

      const deleteCart = async (payload) => {
        try {
          console.log(payload);
          handleLoader(true);
          dispatch(deleteCartAsync(payload._id))
            .unwrap()
            .then((res) => {
              if (res) {
                handleLoader(false);
                SuccessToast('Cart was deleted successfully.');
                fetchData();
              } else {
                handleLoader(false);
              }
            });
        } catch (error) {
          handleLoader(false);
          console.log(error);
        }
      };

      const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 400,
        bgcolor: 'background.paper',
        boxShadow: 24,
        p: 3,
        fontFamily: 'Rubik',
        borderRadius: '6px',
      };

      return (
        <Box display="flex">
          <IconButton onClick={() => handleOpenModal()}>
            <DeleteOutlineRounded color="primary" />
          </IconButton>

          <Modal
            open={openConfirmModal}
            onClose={handleCloseModal}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description">
            <Box sx={style}>
              <Box mb={5} sx={{ fontSize: 20, fontWeight: 'medium' }}>
                Are you sure you want to delete ?
              </Box>
              <Box sx={{ position: 'absolute', top: 5, right: 5 }}>
                <IconButton onClick={handleCloseModal}>
                  <CloseIcon />
                </IconButton>
              </Box>
              <Box display={'flex'} justifyContent="flex-end">
                <Box display={'flex'}>
                  <Box mr={1}>
                    <Button
                      variant="outlined"
                      color="primary"
                      onClick={handleCloseModal}>
                      No
                    </Button>
                  </Box>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => deleteCart(_id)}>
                    Yes
                  </Button>
                </Box>
              </Box>
            </Box>
          </Modal>
        </Box>
      );
    },
  },
];
